import { useTranslation } from 'next-i18next';
import React from 'react';
import { AuthChannelType } from '@hotelplan/fdr.lib.ident.auth-config';
import { useAuthentication } from '@hotelplan/fdr.lib.ident.with-auth';
import FdrBookmarkPdfShare from 'components/domain/fdr-site-tool/fdr-bookmark-pdf-share';
import FdrBookmarkItem from './fdr-bookmark-item';
import {
  BookmarkSectionContentWrapper,
  BookmarkSectionHeader,
} from './fdr-bookmark-section.styles';
import { IBookmarkGroupState, TBookmarkItem } from './fdr-bookmark-types';
import {
  isFdrGeoBookmark,
  isFdrProductBookmark,
  isFdrThemeBookmark,
} from './fdr-bookmark.utils';

interface IBookmarkSectionProps {
  items: Array<TBookmarkItem>;
  activeGroup: IBookmarkGroupState;
  headerTranslationId: string;
  pdfSection?: boolean;
}

export const BookmarkSection: React.FC<IBookmarkSectionProps> = ({
  items,
  activeGroup,
  headerTranslationId,
  pdfSection,
}) => {
  const [t] = useTranslation(['bookmark']);
  const { channelType } = useAuthentication();
  const isB2B = channelType === AuthChannelType.B2B;

  if (!items?.length) {
    return null;
  }

  // BE could return product as null, if the product doesn't exist anymore
  // so items should be filtered
  const filteredItems = items?.filter(item => {
    if (isFdrProductBookmark(item)) {
      return Boolean(item.product);
    }

    if (isFdrGeoBookmark(item)) {
      return Boolean(item.geo);
    }

    if (isFdrThemeBookmark(item)) {
      return Boolean(item.theme);
    }

    return false;
  });

  if (!filteredItems?.length) return null;

  return (
    <>
      <BookmarkSectionHeader>
        <span className="title">{t(headerTranslationId)}</span>
        <span className="total-count">{filteredItems.length}</span>
        {isB2B && pdfSection ? (
          <FdrBookmarkPdfShare items={filteredItems} title={activeGroup.name} />
        ) : null}
      </BookmarkSectionHeader>
      <BookmarkSectionContentWrapper>
        {filteredItems?.map(item => {
          return (
            <FdrBookmarkItem
              key={item.id}
              bookmarkObject={item}
              activeGroup={activeGroup}
            />
          );
        })}
      </BookmarkSectionContentWrapper>
    </>
  );
};
